import {defineMessages} from 'react-intl';

const namespaceLogin = 'login.';
const namespaceRegister = 'register.page.';

export default defineMessages({
  loginTitle: {
    id: `${namespaceLogin}login.title`,
    description: 'Login Title',
    defaultMessage: 'SepaHero Login',
  },
  heroKicker: {
    id: `${namespaceLogin}hero.kicker`,
    description: 'Hero kicker text',
    defaultMessage: 'Welcome Back',
  },
  heroTitle: {
    id: `${namespaceLogin}hero.title`,
    description: 'Hero headline text',
    defaultMessage: 'Stay on top of every mandate',
  },
  email: {
    id: `${namespaceLogin}email`,
    description: 'Email',
    defaultMessage: 'Email',
  },
  mobileNumber: {
    id: `${namespaceRegister}mobile.number`,
    description: 'Mobile number label',
    defaultMessage: 'Mobile number',
  },
  stayLoggedin: {
    id: `${namespaceLogin}stay.logged.in`,
    description: 'Stay logged in',
    defaultMessage: 'Stay logged in',
  },
  passwordForgotten: {
    id: `${namespaceLogin}password.forgotten`,
    description: 'Passwort vergessen',
    defaultMessage: 'Forgotten Password',
  },
  formSalutation: {
    id: `${namespaceLogin}form.salutation`,
    description: 'Login form salutation',
    defaultMessage: 'Hello!',
  },
  formTitle: {
    id: `${namespaceLogin}form.title`,
    description: 'Login form title',
    defaultMessage: 'Log in to your account',
  },
  formSubtitle: {
    id: `${namespaceLogin}form.subtitle`,
    description: 'Login form subtitle',
    defaultMessage: 'Enter your credentials to access SepaHeld®.',
  },
  login: {
    id: `${namespaceLogin}login.button`,
    description: 'Login Button',
    defaultMessage: 'Login',
  },
  register: {
    id: `${namespaceLogin}register.button`,
    description: 'Register Button',
    defaultMessage: 'Register',
  },
  passwortLabel: {
    id: `${namespaceLogin}password.label`,
    description: 'Password Label',
    defaultMessage: 'Password',
  },
  usernameLabel: {
    id: `${namespaceLogin}username.label`,
    description: 'Username Label',
    defaultMessage: 'Username',
  },
  tagLine: {
    id: `${namespaceLogin}tag.line`,
    description: 'TagLine Text',
    defaultMessage: 'Sepa direct debit in next to no time! We link Lexware Office with GoCardless.',
  },
  registerTitle: {
    id: `${namespaceRegister}register.title`,
    description: 'Register Title Label',
    defaultMessage: 'SepaHero Register',
  },
  registerHeroKicker: {
    id: 'register.hero.kicker',
    description: 'Register hero kicker',
    defaultMessage: 'Scale with confidence',
  },
  company: {
    id: `${namespaceRegister}company`,
    description: 'Company Label',
    defaultMessage: 'Company',
  },
  name: {
    id: `${namespaceRegister}name`,
    description: 'Name Label',
    defaultMessage: 'Name',
  },
  firstName: {
    id: `${namespaceRegister}firstName`,
    description: 'Name Label',
    defaultMessage: 'FirstName',
  },
  city: {
    id: `${namespaceRegister}city`,
    description: 'City Label',
    defaultMessage: 'City',
  },
  zip: {
    id: `${namespaceRegister}zip`,
    description: 'Zip Label',
    defaultMessage: 'Zip',
  },
  address: {
    id: `${namespaceRegister}address`,
    description: 'Address Label',
    defaultMessage: 'Address',
  },
  country: {
    id: `${namespaceRegister}country`,
    description: 'Country Label',
    defaultMessage: 'Country',
  },
  registerFormSalutation: {
    id: `${namespaceRegister}form.salutation`,
    description: 'Register form salutation',
    defaultMessage: "Let's get started",
  },
  registerFormTitle: {
    id: `${namespaceRegister}form.title`,
    description: 'Register form title',
    defaultMessage: 'Create your account',
  },
  registerFormSubtitle: {
    id: `${namespaceRegister}form.subtitle`,
    description: 'Register form subtitle',
    defaultMessage: 'Tell us about your business so we can tailor SepaHeld® to you.',
  },
  registerSectionCompany: {
    id: `${namespaceRegister}form.section.company`,
    description: 'Register company section title',
    defaultMessage: 'Company details',
  },
  registerSectionAccount: {
    id: `${namespaceRegister}form.section.account`,
    description: 'Register account section title',
    defaultMessage: 'Account security',
  },
  marketingConsentLabel: {
    id: `${namespaceRegister}marketing.consent.label`,
    description: 'Marketing consent opt-in label',
    defaultMessage: 'I would like to receive marketing emails from SepaHeld',
  },
  marketingConsentDescription: {
    id: `${namespaceRegister}marketing.consent.description`,
    description: 'Marketing consent helper text',
    defaultMessage: 'You can unsubscribe at any time. Learn more in our {privacy}.',
  },
  iAgree: {
    id: `${namespaceRegister}i.agree`,
    description: 'I accept the Terms and Conditions Label',
    defaultMessage: 'I have read the terms and conditions and privacy policy and agree.',
  },
  termsAndConditions: {
    id: `${namespaceRegister}terms.and.conditions`,
    description: 'Terms and Conditions Label',
    defaultMessage: 'Terms and Conditions',
  },
  privacyPolicy: {
    id: `${namespaceRegister}privacy.policy`,
    description: 'Privacy Policy Label',
    defaultMessage: 'Privacy Policy',
  },
  orLabel: {
    id: `${namespaceLogin}or.label`,
    description: 'or Label',
    defaultMessage: 'or',
  },
  twoFactorCode: {
    id: `${namespaceLogin}twofactor.code`,
    description: 'Two factor code label',
    defaultMessage: 'Two-Factor Code',
  },
  twoFactorRequired: {
    id: `${namespaceLogin}twofactor.required`,
    description: 'Two factor required message',
    defaultMessage: 'Two-Factor authentication required. Please enter your code.',
  },
  submitTwoFactor: {
    id: `${namespaceLogin}twofactor.submit`,
    description: 'Submit two factor code',
    defaultMessage: 'Verify Code',
  },
  loginWithPasskey: {
    id: `${namespaceLogin}passkey.button`,
    description: 'Passkey Login Button',
    defaultMessage: 'Login with Passkey',
  },

})